import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';

import Media from 'components/NextconLabMedia/Media';
import MobileMedia from 'components/NextconLabMedia/MobileMedia';

import MobileFooter from 'components/MobileFooter';
import { useEffect } from "react";

function Fmedia() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <MobileMedia/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Media/>
        <Footer />
      </>
    )}
    </>
  );
}

export default Fmedia;
